export default "__VITE_ASSET__BiaTUnlX__"